import i18n from '@dms/i18n';
import {MileageInput} from '@dms/shared';

import {useStepFieldRegistration} from '../hooks/useStepFieldRegistration';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';

interface SimpleNumericFieldProps {
  name: 'mileage';
  vehicleId: string | null;
}

export function SimpleMilageField({name, vehicleId}: SimpleNumericFieldProps) {
  const {control, formApi, mandatoryFields} = useVehicleFormContext();
  useStepFieldRegistration(name);

  return (
    <MileageInput
      control={control}
      formApi={formApi}
      name={name}
      label={i18n.t('entity.vehicle.labels.mileage')}
      vehicleId={vehicleId}
      data-testid="milage"
      shouldShowWarning
      isRequired={mandatoryFields.includes(name)}
      isRecommended={mandatoryFields.includes(name)}
    />
  );
}
